<template>
  <div class="rfp-rr-ratings-helpful-018-or rr-like-review clear float-left">
    <p class="rfp-rr-ratings-helpful-019-or">
      <span class="rfp-rr-ratings-helpful-020-or">{{ helpfulLabel }}</span>
    </p>
    <div class="rfp-rr-ratings-helpful-021-or rr-like-section float-left">
      <p
        role="button"
        tabindex="0"
        :class="{ 'rfp-rr-ratings-helpful-022-or': isHelpful }"
        @keydown.space.prevent
        @keyup.space="updateHelpfulCount(helpfulData)"
        @keydown.enter="updateHelpfulCount(helpfulData)"
        @click="updateHelpfulCount(helpfulData)"
      >
        <img
          :src="helpfulIcon"
          class="image-setup-for-list"
          :class="`rfp-rr-ratings-helpful-${isHelpful ? '23' : '24'}-or`"
          :alt="helpfulIconAlt"
        />
      </p>
      <p>
        <span class="rfp-rr-ratings-helpful-025-or bold">{{ counts.helpfulCount }}</span>
      </p>
      <p
        role="button"
        tabindex="0"
        :class="{ 'rfp-rr-ratings-helpful-026-or': isHelpful }"
        @keydown.space.prevent
        @keyup.space="updateHelpfulCount(notHelpfulData)"
        @keydown.enter="updateHelpfulCount(notHelpfulData)"
        @click="updateHelpfulCount(notHelpfulData)"
      >
        <img
          :src="nonHelpfulIcon"
          :class="`rfp-rr-ratings-helpful-${isHelpful ? '27' : '28'}-or image-setup-for-list`"
          :alt="nonHelpfulIconAlt"
        />
      </p>
      <p>
        <span class="rfp-rr-ratings-helpful-029-or bold">{{ counts.notHelpfulCount }}</span>
      </p>
      <p>
        <a
          v-if="reportDisplayed != rrid && reportReviewText == reportText"
          class="rfp-rr-ratings-helpful-030-or aReported"
          role="button"
          tabindex="0"
          @keydown.space.prevent
          @keyup.space="reportReview"
          @keydown.enter="reportReview"
          @click="reportReview"
          >{{ reportText }}</a
        >
        <span v-else class="rfp-rr-ratings-helpful-031-or aReported">{{ reportedText }}</span>
      </p>
      <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
        <rfp-ratings-social-share
          :url="currentPageUrl"
          :title="productNamess"
          :description="reviewContentss"
          :quote="reviewTitless"
          :facebooks="facebookCaptionss"
          :show-fb-media-texts="shareDisplayConfig"
          :facebook-icons="facebookIcon"
          :facebook-icon-alt="facebookIconAlt"
        >
          <template #default="{ networks, networkTag, share, createSharingUrl }">
            <social-sharing-network
              :networks="networks"
              :network-tag="networkTag"
              :share="share"
              :create-sharing-url="createSharingUrl"
              network="facebook"
            >
              <p>
                <img
                  v-if="
                    facebookIcon != '' && ['Icon and Text', 'Icon'].includes(shareDisplayConfig)
                  "
                  :src="facebookIcon"
                  :title="facebookIconAlt"
                  class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                  :alt="facebookIconAlt"
                  loading="lazy"
                />
              </p>
              <span
                v-if="['Icon and Text', 'Text'].includes(shareDisplayConfig)"
                v-text="facebookCaption"
              ></span>
            </social-sharing-network>
          </template>
        </rfp-ratings-social-share>
      </p>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import axios from 'axios';
import RfpRatingsSocialShare from '../rfp-ratings-social-share/Plugins/rfp-ratings-social-share.vue';
import SocialSharingNetwork from '../rfp-ratings-social-share/Plugins/social-sharing-network.vue';

export default {
  name: 'rfp-ratings-helpful',
  components: {
    RfpRatingsSocialShare,
    SocialSharingNetwork,
  },
  inject: ['counts', 'helpfulCookie', 'isFavReviewSection', 'reportReviewText'],
  props: {
    helpfulLabel: {
      type: String,
      required: true,
    },
    rrid: {
      type: Number,
      required: true,
    },
    reportDisplay: {
      type: Number,
      required: true,
    },
    reportedText: {
      type: String,
      required: true,
    },
    reportText: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApi: {
      type: String,
      required: true,
    },
    updateNotHelpfulReviewApi: {
      type: String,
      required: true,
    },
    reportReviewApi: {
      type: String,
      required: true,
    },
    helpfulIcon: {
      type: String,
      required: true,
    },
    helpfulIconAlt: {
      type: String,
      required: true,
    },
    nonHelpfulIcon: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlt: {
      type: String,
      required: true,
    },
    productNamess: {
      type: String,
      required: true,
    },
    reviewContentss: {
      type: String,
      required: true,
    },
    reviewTitless: {
      type: String,
      required: true,
    },
    facebookCaptionss: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnabled: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfig: {
      type: String,
      required: true,
    },
    facebookIcon: {
      type: String,
      default: '',
    },
    facebookIconAlt: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reportDisplayed: this.reportDisplay,
      cookiesDetaild: [],
      helpfulCountCookieLocal: '',
      currentPageUrl: window.location.href,
      helpfulCountCookie: `helpfulCountCookie${this.rrid}`,
      reportedCookie: `reportedCookie${this.rrid}`,
    };
  },
  computed: {
    isHelpful() {
      return this.helpfulCountCookieLocal != this.rrid && this.helpfulCookie == 'no';
    },
  },
  created() {
    this.helpfulData = {
      tags: 'LikeReviewTags',
      api: this.updateHelpfulReviewApi,
      property: 'localHelpfulCount',
    };

    this.notHelpfulData = {
      tags: 'unLikeReviewTags',
      api: this.updateNotHelpfulReviewApi,
      property: 'localNotHelpfulCount',
    };
  },
  mounted() {
    this.isSuccessful(this.helpfulCountCookie) && (this.helpfulCountCookieLocal = this.rrid);
    this.isSuccessful(this.reportedCookie) && (this.reportDisplayed = this.rrid);
  },
  methods: {
    reportReview() {
      axios
        .patch(this.reportReviewApi, { rrID: this.rrid }, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          response.data.Message === 'Reported' &&
            this.isSuccessful(this.reportedCookie) &&
            (this.reportDisplayed = this.rrid);
        });
    },

    updateHelpfulCount(data) {
      if (!this.isHelpful) return;
      eventBus.emit(data.tags);

      axios
        .patch(data.api, { rrID: this.rrid }, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          this.helpfulCountCookieLocal = '';
          /* set manual cookie in console ($cookie.set(helpfulCountCookie : 'success')) if its local */
          if (
            response.data.Message !== 'Success' ||
            this.$cookies.get(this.helpfulCountCookie) !== 'success'
          )
            return;
          this.helpfulCountCookieLocal = this.rrid;
          const emitMethod = this.isFavReviewSection
            ? 'update-most-favorable-review'
            : 'update-most-critical-review';

          let updateObj = { count: response.data.Count, property: data.property };
          eventBus.emit(emitMethod, updateObj);
        });
    },

    isSuccessful(cookieId) {
      return this.$cookies.get(cookieId) === 'success';
    },
  },
};
</script>
